import { Link } from "react-router-dom";
import { scrollToSection } from "./Navbar";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <p className="font-display font-extrabold text-2xl tracking-tight flex items-center gap-2.5">
            <img src="/lumora-logo.png" alt="Lumora" className="w-8 h-8" />
            LUMORA<span className="text-[#E05638]">.</span>
          </p>
          <p className="text-neutral-400 text-sm mt-4 max-w-xs leading-relaxed">
            Siti web ad alte prestazioni in abbonamento mensile. Design, gestione e SEO sotto lo
            stesso tetto.
          </p>
        </div>
        <div>
          <p className="mono-label text-neutral-500 mb-5">Navigazione</p>
          <div className="flex flex-col gap-3">
            {[
              ["servizi", "Servizi"],
              ["piani", "Piani & Abbonamenti"],
              ["contatti", "Contatti"],
            ].map(([id, label]) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToSection(id)}
                className="text-left text-sm text-neutral-300 hover:text-[#E05638] transition-colors w-max"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="mono-label text-neutral-500 mb-5">Servizi</p>
          <div className="flex flex-col gap-3">
            {[
              ["/creazione-siti-web-novara", "Creazione siti web Novara"],
              ["/web-design-novara", "Web design Novara"],
              ["/seo-novara", "SEO Novara"],
              ["/gestione-siti-web", "Gestione siti web"],
            ].map(([to, label]) => (
              <Link
                key={to}
                to={to}
                data-testid={`footer-link-${to.slice(1)}`}
                className="text-sm text-neutral-300 hover:text-[#E05638] transition-colors w-max"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="mono-label text-neutral-500 mb-5">Contatti</p>
          <p className="text-sm text-neutral-300">lumoratech.it@gmail.com</p>
          <p className="text-sm text-neutral-300 mt-2">Novara · Italia</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="mono-label text-neutral-500">© 2026 Lumora</p>
          <Link
            to="/privacy"
            data-testid="footer-link-privacy"
            className="mono-label text-neutral-500 hover:text-[#E05638] transition-colors"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}
